module.exports = __webpack_public_path__ + "img/logoraaphorst.f73a596c.jpg";